import { AxiosRequestConfig } from 'axios'
import createAPIClient from '../services/apiClient'
import { DeviceType, OtaFirmwareVersionType } from '../enums'

const api = createAPIClient('v2')

/**
 * Get the latest OTA firmware version for the given type.
 */
export async function getLatestOtaFirmwareVersion(
  type: OtaFirmwareVersionType,
  config?: AxiosRequestConfig
): Promise<string> {
  const response = await api.get(`/ota/${type}/latest`, config)

  return response.data
}

/**
 * Get the latest OTA firmware version for the given device type.
 */
export async function getLatestDeviceFirmwareVersion(
  deviceType: DeviceType | null | undefined,
  config?: AxiosRequestConfig
): Promise<string> {
  const type =
    deviceType === DeviceType.VALVE ? OtaFirmwareVersionType.VALVE : OtaFirmwareVersionType.SPINE

  return getLatestOtaFirmwareVersion(type, config)
}
